<script lang="ts">
  import { applyHasSlotContentClass } from "../../actions/applyHasSlotContentClass";
</script>

<svelte:element this={"slot"} name="error" aria-hidden="true" use:applyHasSlotContentClass />

<style lang="scss">
  @use "@otto-ec/design-tokens/component" as tokens;

  :global {
    slot[name="error"] {
      display: block;
      font: tokens.$oc-component-form-hint-font;
      color: tokens.$oc-component-form-error-validation-message-color;
      word-break: break-word;

      /*                       */
      &.--has-slot-content {
        margin-top: tokens.$oc-component-form-hint-gap-y;
      }
    }
  }
</style>
